import { render, staticRenderFns } from "./applicants.vue?vue&type=template&id=e780791c&scoped=true&"
import script from "./applicants.vue?vue&type=script&lang=js&"
export * from "./applicants.vue?vue&type=script&lang=js&"
import style0 from "./applicants.vue?vue&type=style&index=0&id=e780791c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e780791c",
  null
  
)

export default component.exports